import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENDPOINTS } from '../../apis/endpoints';
import { setCredentials } from '../../features/Auth/authSlice';
import { clearAuth } from '../../features/Auth/Utility/ClearAuth';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  try {

    let result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === 403) {
      const refreshResult = await baseQuery(ENDPOINTS.AUTH.REFRESH_TOKEN, api, extraOptions);
      if (refreshResult?.data) {
        const user = api.getState().auth.user;
        api.dispatch(setCredentials({ ...refreshResult.data, user }));
        result = await baseQuery(args, api, extraOptions);
      } else {
        clearAuth(api.dispatch);
      }
    }
    return result;
  } catch (error) {
    console.log("Something went wrong", error);
  }
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'User',
    'Employee',
    'Resume',
    'Comment',
    'Delight',
    'Shabash',
    'GiftForm',
    'GiftInterview',
    'Nomination',
    'Winner',
    'Quarter',
    'Profile',
    'Events',
    'News',
    'Permission',
    'Chat',
    'Feedback',
    'NewOpenings',
    'ReferralData',
    'Refreshments'
  ],
  endpoints: (builder) => ({}),
});
